import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { AgentModule } from '../agent/agent.module'
import { RouterModule } from '@angular/router'
import { InitializeTransferCommissionComponent } from './initializeTransferCommission/initialize-transfer-commission.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        AgentModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        InitializeTransferCommissionComponent
    ],
    exports: [InitializeTransferCommissionComponent]
})
export class TransferCommissionModule {}
